import { z } from "zod";
import { activityFilterGroupSchema } from "./activity-filter";
import { directoryFilterSchema, type RecordFilterGroup } from "./record-filter";

export const savedFilterKind = z.enum(["person", "company", "activity"]);
export type SavedFilterKind = z.infer<typeof savedFilterKind>;
export const savedFilterInput = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("person"),
    name: z.string().trim().min(1),
    filter: directoryFilterSchema("person"),
  }),
  z.object({
    kind: z.literal("company"),
    name: z.string().trim().min(1),
    filter: directoryFilterSchema("company"),
  }),
  z.object({
    kind: z.literal("activity"),
    name: z.string().trim().min(1),
    filter: activityFilterGroupSchema,
  }),
]);
export type SavedFilterInput = z.infer<typeof savedFilterInput>;
export interface SavedFilter {
  id: string;
  name: string;
  kind: SavedFilterKind;
  filter: RecordFilterGroup;
}
type Json<T> = { content: { "application/json": T } };
export interface SavedFilterPaths {
  "/saved-filters": {
    get: {
      parameters: { query: { kind: SavedFilterKind } };
      responses: { 200: Json<SavedFilter[]> };
    };
    post: { requestBody: Json<SavedFilterInput>; responses: { 201: Json<SavedFilter> } };
  };
  "/saved-filters/{id}": {
    delete: { parameters: { path: { id: string } }; responses: { 204: { content?: never } } };
  };
}
